import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import { Form, Input, Icon } from 'semantic-ui-react';
import CancelGoButtons from 'components/CancelGoButtons';
import API from 'utils/api';

class MenuCategoryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valid: false,
      loading: false,
      error: null,
      category_id: null,
      name: '',
    };
  }

  componentDidMount() {
    // If editing, get the category ID from the URL parameter
    if (this.props.editing && this.props.match.params.categoryId) {
      const categoryId = this.props.match.params.categoryId;
      this.setState({ loading: true, error: null });
      
      API.getProductCategories()
        .then((response) => {
          const categories = response.data;
          const category = categories.find(c => c.id === parseInt(categoryId));
          
          if (category) {
            this.setState({
              category_id: category.id,
              name: category.name,
              valid: category.name.trim() !== '',
              loading: false
            });
          } else {
            this.setState({ 
              loading: false,
              error: 'No se encontró la categoría' 
            });
            console.error('Category not found');
          }
        })
        .catch((error) => {
          this.setState({ 
            loading: false,
            error: 'Error al cargar la categoría'
          });
          console.error(error);
        });
    }
  }

  handleName = (event) => {
    this.setState({ name: event.target.value }, this.validate);
  }
  
  validate = () => {
    let valid = true;
    if (this.state.name.trim() === '') { valid = false; }
    this.setState({ valid });
  }

  createProductCategory = () => {
    if (this.state.valid) {
      this.setState({ loading: true, error: null });
      
      const params = {
        name: this.state.name
      };

      API.createProductCategory(params)
        .then((response) => {
          // Wait a moment to ensure the database has time to update
          setTimeout(() => {
            this.props.history.push('/menu/products');
          }, 500);
        })
        .catch((error) => {
          this.setState({ 
            loading: false,
            error: 'Error al crear la categoría'
          });
          console.error(error);
        });
    }
  }
  
  updateProductCategory = () => {
    if (this.state.valid && this.state.category_id) {
      this.setState({ loading: true, error: null });
      
      const params = {
        name: this.state.name
      };

      API.updateCategoryName(this.state.category_id, params)
        .then((response) => {
          // Wait a moment to ensure the database has time to update
          setTimeout(() => {
            this.props.history.push('/menu/products');
          }, 500);
        })
        .catch((error) => {
          this.setState({ 
            loading: false,
            error: 'Error al actualizar la categoría'
          });
          console.error(error);
        });
    }
  }

  render() {
    return (
      <div>
        <Header text={this.props.editing ? 'Editar categoría del menú' : 'Agregar categoría al menú'} />

        {this.state.loading ? (
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Icon loading name='spinner' size='large' />
            <p style={{ marginTop: '1em', color: '#666' }}>Cargando...</p>
          </div>
        ) : (
          <Form as='div' style={{ marginTop: '1.5em' }}>
            <Form.Field style={{ marginBottom: '1.5em' }}>
              <label style={{ fontSize: '1.1em', color: '#666', marginBottom: '8px', display: 'block' }}>
                Nombre de la categoría:
              </label>
              <Input
                value={this.state.name}
                onChange={this.handleName}
                placeholder="Ejemplo: Bebidas"
                disabled={this.state.loading}
                style={{ fontSize: '1.2em', height: '54px' }}
              />
            </Form.Field>
            
            {this.state.error && (
              <div style={{ 
                color: '#db2828', 
                marginBottom: '1.5em', 
                padding: '12px', 
                backgroundColor: '#fff6f6', 
                borderRadius: '4px',
                fontSize: '1.1em'
              }}>
                {this.state.error}
              </div>
            )}
          
            <CancelGoButtons
              cancelFn={ () => this.props.history.push('/menu/products') }
              goText={this.props.editing ? 'actualizar categoría' : 'crear categoría' }
              goFn={this.props.editing ? this.updateProductCategory : this.createProductCategory}
              goEnabled={this.state.valid && !this.state.loading}
              loading={this.state.loading}
              style={{
                button: {
                  height: '54px',
                  fontSize: '1.1em',
                  fontWeight: 'bold',
                  boxShadow: 'none',
                  borderRadius: '8px'
                }
              }}
            />
          </Form>
        )}
      </div>
    )
  }
}

export default withRouter(MenuCategoryForm);